import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

export default class FestivalSponsorSidebar extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    whichLinkActive: 'sponsorship'
  }

  handleClick = (linkClicked) => {
    this.setState({whichLinkActive: linkClicked});
  }

  render() {
    let topLinks;


    let sidebarLinks = this.props.festivalSponsorshipCategories;
    let tapStatus = this.props.tapStatus;
    let handleTap = this.props.handleTap;
    let sidebarLinkList;
    let range;
    let rangeList;

    if (this.state.whichLinkActive == 'our-sponsors') {
      topLinks = <div>
        <div onClick={this.handleClick.bind(this, 'our-sponsors')} className="festivalSidebar-header-no-bkgd our-sponsors hide">
          <Link  to="/girls-festival/our-sponsors">Our current sponsors</Link>
        </div>
        <div onClick={this.handleClick.bind(this, 'sponsorship')} className="festivalSidebar-header-no-bkgd sponsorship">
          <Link to="/girls-festival/sponsorship">Become a sponsor</Link>
        </div>
      </div>;
    } else if (this.state.whichLinkActive == 'sponsorship') {
      topLinks = <div>
        <div onClick={this.handleClick.bind(this, 'our-sponsors')} className="festivalSidebar-header-no-bkgd our-sponsors hide">
          <Link to="/girls-festival/our-sponsors">Our current sponsors</Link>
        </div>
        <div onClick={this.handleClick.bind(this, 'sponsorship')} className="festivalSidebar-header-no-bkgd sponsorship">
          <Link  to="/girls-festival/sponsorship">Become a sponsor</Link>
        </div>
      </div>;
    }





    return(
      <div className={`festivalSponsors-mobileMenuWrapper ${tapStatus}`}>
        {topLinks}
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/festival/sponsorship/FestivalSponsorSidebar.jsx